import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { ButtonComponent } from "@shared/controls/button/button.component";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { ColDef } from "ag-grid-enterprise";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ExportTypeEnum } from "@models/common/export-type.enum";

interface CustomColDef extends ColDef {
  field?: string;
  headerName?: string;
  hide?: boolean;
}

@Component({
  selector: 'app-export-company-list',
  standalone: true,
  imports: [
    DividerComponent,
    ButtonComponent,
    CheckboxComponent
  ],
  templateUrl: './export-entity-list-modal.component.html',
  styleUrl: './export-entity-list-modal.component.scss'
})
export class ExportEntityListModalComponent implements OnInit {
  modal = inject(NgbActiveModal);

  @Input() title = 'Export Company List';
  @Input() subTitle = 'companies selected';
  @Input() colDefs: CustomColDef[] = [];
  @Input() numberOfCompanies = 0;
  @Input() exportType: ExportTypeEnum = ExportTypeEnum.EXCEL;

  @Output() confirm = new EventEmitter<string[]>();
  @Output() resetPagination = new EventEmitter<boolean>();

  selectAll = false;
  exportColDefs!: CustomColDef[];

  get numberSelectedColumns(): number {
    return this.exportColDefs?.filter(c => !c.hide && c.headerName)?.length ?? 0;
  }

  ngOnInit(): void {
    //workaround for tags column to avoid duplication
    this.exportColDefs = this.colDefs?.filter((colDef, index, self) =>
      colDef.headerName &&
      index === self.findIndex(c => c.headerName === colDef.headerName)
  ) ?? [];
  }

  onExport(): void {
    const columnsForExport = this.colDefs?.filter(c => !c.hide && c.headerName)
      .map(c => c.field) as string[];
    this.confirm.emit(columnsForExport);
    this.modal.close();
  }

  onClose(): void {
    this.resetPagination.emit(true);
    this.modal.close();
  }

  onCheckboxChange(index: number): void {
    if(this.exportColDefs?.length) {
      this.exportColDefs[index].hide = !this.exportColDefs[index].hide;
    }

    const columnWithHeaderName = this.exportColDefs?.filter(c => c.headerName) ?? [];
    const selectedColumnNumber = columnWithHeaderName?.filter(c => !c.hide)?.length ?? 0;

    this.selectAll = columnWithHeaderName?.length === selectedColumnNumber;
  }

  onSelectAllChange(selected: boolean): void {
    this.exportColDefs?.forEach(c => {
      if(c.headerName) {
        c.hide = !selected;
      }
    });

    this.selectAll = selected;
  }
}
